export default __webpack_public_path__ + "static/signup-success-781ab21c9186a298588895b96c7d1b2b.svg";